
// GoogleBtn.jsx - ONLY for fetching data, NOT for registration
import { useEffect } from "react";

const GoogleBtn = ({ onDataFetch }) => {
  const handleGoogle = async (res) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SECRET_KEY}/api/google-fetch-data`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ token: res.credential }),
      });

      const data = await response.json();
      
      if (data.success) {
        // console.log("✅ Google Data Fetched:", data);
        
        // ✅ Call parent callback to fill form
        if (onDataFetch) {
          onDataFetch(data.userData);
        }
      } else {
        // console.error("❌ Failed to fetch data:", data.message);
      }
    } catch (err) {
      // console.error("❌ Fetch error:", err);
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: "352658337613-avge96j2ukob9luip66cqhapiofjom4g.apps.googleusercontent.com",
          callback: handleGoogle,
          ux_mode: "popup",
          context: "signin",
        });

        window.google.accounts.id.renderButton(
          document.getElementById("googleBtn"),
          { 
            theme: "outline", 
            size: "large",
            text: "continue_with", // "Continue with Google"
            shape: "rectangular",
            width: 250
          }
        );
      }
    };

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
     <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      margin: '0 auto'
    }}>
 
      <div id="googleBtn"></div>
    </div>
  );
};

export default GoogleBtn;